// extracted by mini-css-extract-plugin
export default {"emailLink":"universum_emailLink__EBgyp"};